<template>
  <div
    v-if="hasMessages"
    id="messages-container"
    class="alert"
    role="alert"
    aria-label="validations"
    :class="message_style_class"
  >
    <span class="font-weight-bold">{{ title }}</span>
    <ul class="mt-3">
      <li v-for="(message, key) in messages" :id="key" :key="key" :aria-label="key" role="listitem">
        <div v-html= message></div>
      </li>
    </ul>
  </div>
</template>

<script>
import { isEmptyObject } from "common/object_utils";

export default {
  name: "forms-messages-list-vue",
  props: {
    title: { type: String, default: ""},
    messages: { type: Object, default: {}, require: true },
    single_message: { type: Boolean, default: false },
    notification_message: { type: Boolean, default: false }
  },
  computed: {
    hasMessages: function () {
      return !isEmptyObject(this.messages);
    },
    message_style_class() {
      let class_name = this.notification_message ? "alert-secondary" : "alert-danger";
      return this.single_message ? class_name + " m-3 p-0" : class_name;
    }
  }
};
</script>
